import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// core components
import routes from '../../routes/routes.js';

class Auth extends React.Component {
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
            exact={true}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <Switch>
        {this.getRoutes(routes)}
        <Redirect from="*" to="/auth/login" />
      </Switch>
    );
  }
}

export default Auth;
